import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard } from 'swiper';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import 'swiper/css';
import Style from './index.css';
import tbc from './tbc.png';

const Page2 = (props) => {
    const { peopleList, onChangeMaskVisible, onChangeCurrentVideo, peopleIndex, onChangePeopleIndex } = props;

    const openVideo = (video) => {
        onChangeCurrentVideo({
            url: video.videoUrl,
            duration: video.videoDuration,
            guid: video.videoGuid,
        });
        onChangeMaskVisible(true);
    };

    const hasVideoList = Array.isArray(peopleList[peopleIndex]?.videoList) && peopleList[peopleIndex]?.videoList.length;

    return (
        <div className={Style.page2}>
            {hasVideoList ? (
                <>
                    <div className={Style.swiperWp}>
                        <img className={Style.navigation} id="page2_prev" src="https://x0.ifengimg.com/ucms/2023_45/F596FFF41C138E433BFD5C2A95A3562BB8D66411_size3_w62_h118.png" alt="" />

                        <Swiper
                            key={peopleIndex}
                            modules={[Navigation, Pagination, Keyboard]}
                            className={Style.swiper}
                            slidesPerView={3}
                            slidesPerGroup={3}
                            speed={1500}
                            navigation={{
                                prevEl: '#page2_prev',
                                nextEl: '#page2_next',
                            }}
                            pagination={{
                                el: `.${Style.pagination}`,
                                type: 'fraction',
                            }}
                            keyboard={{
                                enabled: true,
                            }}>
                            {peopleList[peopleIndex]?.videoList.map((video, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <div className={Style.swiperItem} onClick={() => openVideo(video)}>
                                            <div className={Style.video}>
                                                <img className={Style.poster} src={formatImageWebpAuto(video.poster, 450, 244)} alt="" />
                                                <div className={Style.mask}>
                                                    <img className={Style.play} src="https://x0.ifengimg.com/ucms/2023_45/D973BCD50EFB6AB19BF7D79BC6898A554C1B2C29_size3_w59_h59.png" alt="" />
                                                </div>
                                            </div>
                                            <div className={Style.title}>
                                                <div className={Style.titleText}>{video.title}</div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>

                        <img className={Style.navigation} id="page2_next" src="https://x0.ifengimg.com/ucms/2023_45/040E0DEB52C8354E27039A17D37383D5BA19F8A2_size3_w62_h118.png" alt="" />
                    </div>

                    <div className={Style.pagination} />
                </>
            ) : (
                <div className={Style.swiperEmpty}>
                    <img src={tbc} alt="" />
                </div>
            )}

            <div className={Style.peopleList}>
                {peopleList.map((people, index) => {
                    return (
                        <div key={index}>
                            <div className={`${Style.people} ${index === peopleIndex ? Style.active : ''}`} onClick={() => onChangePeopleIndex(index)}>
                                {people.name}
                            </div>
                            {index < peopleList.length - 1 && <span className={Style.divider}>/</span>}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

Page2.propTypes = {
    peopleList: PropTypes.array,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
    peopleIndex: PropTypes.number,
    onChangePeopleIndex: PropTypes.func,
};

export default errorBoundary(Page2);
